/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Документы записи (лицензии и история статусов; только ТЗ)
 * @export
 * @interface GetRegistry200ResponseDataDocuments
 */
export interface GetRegistry200ResponseDataDocuments {
  /**
   * Лицензии
   * @type {object}
   * @memberof GetRegistry200ResponseDataDocuments
   */
  licences?: object | null
  /**
   * История статусов
   * @type {Array<object>}
   * @memberof GetRegistry200ResponseDataDocuments
   */
  history?: Array<object>
}

/**
 * Check if a given object implements the GetRegistry200ResponseDataDocuments interface.
 */
export function instanceOfGetRegistry200ResponseDataDocuments(
  value: object
): value is GetRegistry200ResponseDataDocuments {
  return true
}

export function GetRegistry200ResponseDataDocumentsFromJSON(
  json: any
): GetRegistry200ResponseDataDocuments {
  return GetRegistry200ResponseDataDocumentsFromJSONTyped(json, false)
}

export function GetRegistry200ResponseDataDocumentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistry200ResponseDataDocuments {
  if (json == null) {
    return json
  }
  return {
    licences: json['licences'] == null ? undefined : json['licences'],
    history: json['history'] == null ? undefined : json['history'],
  }
}

export function GetRegistry200ResponseDataDocumentsToJSON(
  value?: GetRegistry200ResponseDataDocuments | null
): any {
  if (value == null) {
    return value
  }
  return {
    licences: value['licences'],
    history: value['history'],
  }
}
